import type { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponse } from '../../../../common/models/api-response.interface';
import { APP_SETTINGS } from '../../app-settings';
import {
    PartnerDetail,
    Proxy,
    ProxyType
} from '../../../../common/models/search.interface';
import {
    PreferredPaymentModePayload,
    ReprocessPaymentResponsePayload,
    PreferredPaymentMode
} from '../../../../common/models/payments.interface';

@Injectable()
export class SharedStoreService {
    constructor(
        private http: HttpClient,
        @Inject(APP_SETTINGS) private appSettings
    ) {}

    getPartnerData(): Observable<ApiResponse<PartnerDetail[]>> {
        return this.http.get<ApiResponse<PartnerDetail[]>>(
            `${this.appSettings.apiEndpoint}picklist/partners`
        );
    }

    transformToDropdownList(dataArray: PartnerDetail[] | Proxy[]) {
        let listArray = [];
        let checkIfTypeProxy = (data: PartnerDetail | Proxy): data is Proxy => {
            return (data as Proxy).proxy_name !== undefined;
        };
        let isOfTypeProxy = checkIfTypeProxy(dataArray[0]);
        dataArray.forEach((data) => {
            let elem = isOfTypeProxy
                ? {
                      label:
                          ProxyType[data['proxy_name']] ??
                          data['proxy_description'],
                      value: data['proxy_name']
                  }
                : {
                      label: data['partner_name'],
                      value: data['partnerSearchToken']
                  };
            listArray.push(elem);
        });
        return listArray;
    }

    getPreferredPaymentMode(
        searchToken: string
    ): Observable<ApiResponse<PreferredPaymentModePayload>> {
        const url = `${this.appSettings.apiEndpoint}payments/preferredPaymentMode`;
        const options = {
            params: new HttpParams().set('searchToken', searchToken)
        };
        return this.http.get<ApiResponse<PreferredPaymentModePayload>>(
            url,
            options
        );
    }

    transformToPreferredPaymentMode(paymentMode: string): string {
        if (paymentMode?.trim()?.toLowerCase()?.includes('paypal')) {
            return PreferredPaymentMode.PayPal;
        }
        if (paymentMode?.trim()?.toLowerCase()?.includes('venmo')) {
            return PreferredPaymentMode.Venmo;
        }
        return paymentMode;
    }

    setPreferredPaymentMode(
        payload: PreferredPaymentModePayload
    ): Observable<ApiResponse<ReprocessPaymentResponsePayload>> {
        const queryStringParams = {
            params: new HttpParams({
                fromString: `searchToken=${payload.searchToken}`
            })
        };
        const modifiedPayload = {
            payment_mode: this.transformToPreferredPaymentMode(
                payload.payment_mode
            ),
            identifier_type: payload.identifier_type,
            identifier_value: payload.identifier_value
        };
        const url = `${this.appSettings.apiEndpoint}payments/setPreferredPayoutMethod`;
        return this.http.post<ApiResponse<ReprocessPaymentResponsePayload>>(
            url,
            modifiedPayload,
            queryStringParams
        );
    }
}
